import { derived } from 'svelte/store';
import { writable } from './localStorageStore';

export const rounds = writable('rounds', 4);
export const timeOn = writable('timeOn', 3);
export const timeOff = writable('timeOff', 1);
export const playSounds = writable('playSounds', false);

export const totalTime = derived([rounds, timeOn, timeOff], ([$rounds, $timeOn, $timeOff]) => ($timeOn * $rounds) + ($timeOff * ($rounds - 1)), 0);
